module.exports = __webpack_public_path__ + "img/13.1e40486c.jpg";